/** CSV/TSV stays text: formulas and markup never execute in the preview. */
// shortcut: preview caps at 200 rows / 100 columns; add virtual scrolling if larger tables need in-chat browsing.
export function documentTable(content: string): { rows: string[][]; truncated: boolean } {
	const separator = delimiter(content);
	const rows: string[][] = [];
	let row: string[] = [];
	let cell = "";
	let quoted = false;
	for (let i = 0; i < content.length; i++) {
		const char = content[i];
		if (char === '"' && (quoted || cell.length === 0)) {
			if (quoted && content[i + 1] === '"') {
				cell += '"';
				i++;
			} else quoted = !quoted;
		} else if (!quoted && char === separator) {
			row.push(cell);
			cell = "";
		} else if (!quoted && (char === "\n" || char === "\r")) {
			if (char === "\r" && content[i + 1] === "\n") i++;
			row.push(cell);
			rows.push(row);
			row = [];
			cell = "";
			if (rows.length >= 200) return { rows, truncated: i < content.length - 1 };
		} else cell += char;
		if (row.length >= 100) return { rows: [...rows, row], truncated: true };
	}
	if (cell.length + row.length > 0) rows.push([...row, cell]);
	return { rows, truncated: false };
}

function delimiter(content: string): string {
	const counts: Record<string, number> = { ",": 0, ";": 0, "\t": 0 };
	let quoted = false;
	for (let i = 0; i < content.length; i++) {
		const char = content[i] ?? "";
		if (char === '"') {
			if (quoted && content[i + 1] === '"') i++;
			else quoted = !quoted;
			continue;
		}
		if (quoted) continue;
		if (char === "\n" || char === "\r") break;
		if (char in counts) counts[char] = (counts[char] ?? 0) + 1;
	}
	return Object.entries(counts).sort((a, b) => b[1] - a[1])[0]?.[0] ?? ",";
}
